package io.horion.cv.models

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue

class Requierement(
    val id: String,
    requierement: String = ""
) {
    var requierement by mutableStateOf(requierement)
}